<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
    >
      <v-list dense>

        <v-list-item link :to="{ name: 'projects' }" @click="drawer = false">
          <v-list-item-action>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Projecten</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="user.is_admin"
          link
          :to="{ name: 'users' }"
          @click="drawer = false"
        >
          <v-list-item-action>
            <v-icon>mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Gebruikers</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'logout' }" @click="drawer = false">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Uitloggen</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-left
    >
      <v-app-bar-nav-icon
        v-if="isLoggedIn"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <img src="/logo.svg" height="80%" class="mr-3" />
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>

    <loading :active="!!isLoading" 
        :can-cancel="true"
        :on-cancel="cancelLoading"
        color="#eb5e0c"
        background-color="#222222"
        :is-full-page="true"
        loader="dots"
        :width="64"
        :height="64"
    ></loading>    

    <v-footer app>
      <span>&copy; {{ new Date().getFullYear() }}</span>
      <v-spacer></v-spacer>
      <span>{{ user.full_name }} {{ user.is_admin ? '(beheerder)' : '' }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'App',
  components: {
    Loading,
  },
  data: () => ({
    drawer: false,
  }),
  computed: {
    ...mapGetters('auth', {
      isLoggedIn: 'isLoggedIn',
    }),
    ...mapState('session', ['isLoading']),
    ...mapState('auth', ['user']),
  },
  methods: {
    cancelLoading(mouseEvent) {
      if (mouseEvent === undefined) {
        this.$store.dispatch('session/hideLoader', true)
      }
    }
  },
  created() {
    this.$vuetify.theme.dark = true
  },
}
</script>


<style>
</style>
